import { APP_BASE_HREF } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-headernew',
  templateUrl: './headernew.component.html',
  styleUrls: ['./headernew.component.scss']
})
export class HeaderNewComponent implements OnInit{
  
  lang?:string='ITA';
  url_it:string="";
  url_en:string="";
  constructor(private router : Router){
  
   
   
  }

  getSkipLink(){

    return this.router.url.split('#')[0];

  }
  ngOnInit(): void {
    this.router.events.subscribe(() => {
      let url = window.location.href;
      this.url_it=url.replaceAll("/en/","/it/");
      this.url_en=url.replaceAll("/it/","/en/");
      if (url.endsWith('/en') || url.includes('/en/')){
        this.lang = 'ENG';
        
      }
      if (url.endsWith('/it') || url.includes('/it/')){
        this.lang = 'ITA'
      }
    });
  }
}
